export const selectPickupLocation = state =>
  state.location.pickupLocation;

export const selectDropoffLocation = state =>
  state.location.dropoffLocation;

export const selectPickupMode = state => state.location.pickupMode;

